import { html } from "htm/preact";
import { useState } from "preact/hooks"

import { get } from "./http"


const triggerGamificationRule = (actionName) => {
  const eventId = window.dataLayer[0]["Event ID"]
  const regId = window.dataLayer[0]["Registrant ID"]
  const firstName = window.dataLayer[0]["First Name"]
  const lastName = window.dataLayer[0]["Last Name"]

  const registrantId = `${regId}_${firstName}_${lastName}`

  const query = { registrantId, actionName, swoogoAccess: false, eventId }

  get("https://sponsor-gamification.herokuapp.com/dynamic", query)
}

export const Background = ({ imgURL, style }) =>
  imgURL.match(/\.mp4$/)
  ? html`<video
    key=${imgURL}
    style="position: absolute; left: 0; width: 100%; top: 0; height: 100%; ${style}"
    id="main-video"
    muted
    loop
    autoplay
  >
    <source src=${imgURL} />
  </video>`
  : html`<img
    key=${imgURL}
    id="main-image"
    src=${imgURL}
    style=${`width: 100%; ${style}`}
  />`;

export const Link = ({
  href = null,
  target = null,
  onClick = null,
  width,
  height,
  left,
  top,
  label,
  title = "",
  elfsightPopupID = null,
  modal = null,
  roomName = "",
  flyzooChatID = null,
  flyzooChatName = "unnamed",
  children = null,
  position = "absolute",
  isExternal = undefined,
  gameRule = null,
}) => {
  const optionals = {}
  const [modalVisible, toggleModal] = useState(false);
  let isRedirectTrackingLink = !isExternal && href?.length && !href.startsWith("http") && !href.startsWith("/")

  if (!onClick) {
    if (modal) { onClick = () => toggleModal(!modalVisible) }
    else if (flyzooChatID) { onClick = () => window.FlyzooApi.startGroupChat(flyzooChatID, flyzooChatName) }
    else if (isRedirectTrackingLink) { onClick = () => window.redirectTracking(href, 1) }
  }

  if (!isRedirectTrackingLink && href) optionals.href = href

  const className = roomName ? "_gtm-event" : "";

  return html`
    <a
      key=${`${label}-${roomName}`}
      target=${target}
      onClick=${() => {
        onClick && onClick()
        gameRule && triggerGamificationRule(gameRule)
      }}
      id=${label}
      data-event-category=${roomName}
      data-event-action="Link Click"
      data-event-label=${label}
      title=${label}
      aria-label=${label}
      class=${className}
      style="
        width: ${width};
        height: ${height};
        left: ${left};
        top: ${top};
        position:${position};
        cursor: pointer;
      "
      ...${optionals}
    >${children}<//>
    ${modal && modalVisible && html`<${Modal} dismiss=${() => toggleModal(false)}>${modal}<//>`}
    ${elfsightPopupID && html`<${ElfsightPopup} ID=${elfsightPopupID} />`}
  `;
};

export const AccessBlock = ({ text = "This is an ISF members-only access point" }) => html`
  <div
    style="padding: 25px; background-color: #1C2545; color: white; border-radius: 10px"
  >
    <h1>${text}<//>
    <p><small>Click anywhere outside this popup to close<//><//>
  <//>
`;

export const ElfsightPopup = ({ trigger, ID }) => html`
  ${trigger && html`<div id=${trigger} />`}
  <div class="elfsight-app-${ID}" />
`;

export const Modal = ({ children, dismiss }) => html`
  <div
    style="background: rgba(255, 255, 255, 0.5); position: fixed; left: 0; top: 0; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; z-index: 100; overflow: auto"
    onClick=${e => { e.stopPropagation(); dismiss() }}
  >
    <div
      style="position: relative; max-width: 100%; max-height: 100%"
      onClick=${(e) => {
    console.log(e);
    e.stopPropagation();
  }}
      >${children}
      <a
        style="cursor: pointer; position: absolute; right: 0; top: 0; width: 50px; height: 50px"
        onClick=${dismiss}
      ><//>
    <//>
  <//>
`;

export const MappedImage = ({ imageURL, links = [], imageStyle = "", children = null }) => html`
  <div style="position: relative;">
    <${Background} imgURL=${imageURL} style=${imageStyle} />
    <${Links} links=${links} />
    ${children}
  </div>
`;

export const Links = ({ links, roomName }) =>
  html` ${links.map(
    (link) => html`<${Link} ...${link} roomName=${roomName} />`
  )}`;

export const App = ({
  links,
  pageBackgroundURL,
  roomName,
  styles = "",
  before = null,
  extras = null,
  onClick = () => { },
}) => html`
  <div style="z-index: 5;">${before}<//>
  <div onClick=${onClick} style="position: relative; ${styles}">
    <${Background} imgURL=${pageBackgroundURL} />
    <${Links} links=${links} roomName=${roomName} />
    ${extras}
  <//>
`;
